import { useMutation, useQuery } from "@tanstack/react-query";
import React from "react";
import { getReceipts, deleteReceiptId } from "../../api/receipts.api";
import { queryError, showAlert } from "../../utils/helpers";

const AdminReceipts = () => {
  const { data, refetch } = useQuery(['admin-receipts'], getReceipts, {
    onSuccess: (res) => {
      if (!res.status) {
        return showAlert({
          title: "Oops!",
          msg: res.errors ? res.errors[0].msg : res.message,
          icon: "error"
        });
      }
    },
    onError: () => queryError()
  });

  const receipts = data?.value || [];

  const { mutate: deleteRec } = useMutation(deleteReceiptId, {
    onSuccess: (res) => {
      if (!res.status) return queryError();
      showAlert({ title: "Success", msg: "Receipt deleted successfully", icon: "success" });
      refetch();
    },
    onError: () => queryError()
  });

  const handleDelete = async (id) => {
    let conf = window.confirm("Are you sure you want to delete this receipt?");
    if (!conf) return;
    deleteRec({ id });
  };

  return (
    <div className="sb-masonry-grid">
      <div className="sb-grid-sizer" />
      {receipts.map(receipt => (
        <div key={receipt._id} className="sb-grid-item sb-item-33">
          <div className="sb-menu-item sb-mb-30">
            <div className="sb-card-tp">
              <h4 className="sb-card-title">{receipt.title}</h4>
            </div>
            <div className="sb-description" style={{ textAlign: "center" }}>
              {receipt.format === 'pdf' ? (
                <iframe src={receipt.fileUrl} width="100%" height="200px" title={receipt.title} className="mb-3"></iframe>
              ) : (
                <img src={receipt.fileUrl} alt={receipt.title} style={{ width: "100%", height: "200px", objectFit: "cover" }} className="mb-3" />
              )}
              <br/>
              <button className="btn btn-sm btn-danger" onClick={() => handleDelete(receipt._id)}>
                <i className="fa fa-trash-alt"></i> Delete
              </button>
            </div>
          </div>
        </div>
      ))}
      {receipts.length === 0 && <p style={{textAlign:"center", width: "100%"}}>No receipts uploaded yet.</p>}
    </div>
  );
};

export default AdminReceipts;
